import React from 'react';
import PropTypes from 'prop-types';
import './SidebarImage.css';

/**
 * A reusable component for displaying an image in the sidebar
 * Using BEM naming convention for CSS classes
 */
const SidebarImage = ({ 
  src,
  alt,
  className = ''
}) => {
  if (!src) return null;
  
  return (
    <div className={`sidebar__section sidebar__image ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className="sidebar__image-img" 
      />
    </div>
  );
};

SidebarImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default SidebarImage;